<template>
    <div id="ManageCompany">

        <div class="text-center">
            <b-spinner variant="primary" class="align-middle" v-if="loading" style="position:absolute;top:50%"></b-spinner>
        </div>

        <b-container>
            <b-row>
                <b-col cols="5">
                    <b-form-group>
                        {{$t('COM_NAME')}}
                        <b-form-input
                                v-model.trim="$v.companyName.$model"
                                :state="validateState('companyName')"
                                aria-described-by="input-1"
                        ></b-form-input>
                        <b-form-invalid-feedback
                                id="input-1"
                        >{{$t('R_ITEM_NAME')}}
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col cols="5">
                    <b-form-group>
                        {{this.$t('URL_HOME')}}
                        <b-form-input
                                v-model.trim="$v.homeUrl.$model"
                                :state="validateState('homeUrl')"
                                aria-described-by="input-4"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="2">
                    <br>
                    <b-form-group v-slot="{ ariaDescribedby }">
                        <b-form-radio v-model="selected" :aria-describedby="ariaDescribedby" name="locale" value="ru">ru</b-form-radio>
                        <b-form-radio v-model="selected" :aria-describedby="ariaDescribedby" name="locale" value="en">en</b-form-radio>
                    </b-form-group>
                </b-col>

            </b-row>
        </b-container>

        <b-container fluid class="footer text-center" v-show="!loading">
            <b-button class="m-1" @click="ok()">{{$t('SAVE')}}</b-button>
            <b-button class="m-1" @click="cancel()">{{$t('CANCEL')}}</b-button>
            <b-button class="m-1" @click="showHelp=true"><font-awesome-icon icon="question" size="lg" :style="{ color: 'white' }" /></b-button>
        </b-container>

        <Help
                v-on:closeHelp="showHelp=false"
                v-bind:helpName="helpName"
                v-if="showHelp"
        />

    </div>
</template>

<script>
import { BContainer, BRow, BCol, BButton, BFormGroup, BFormInput,
    BFormInvalidFeedback, BSpinner, BFormRadio } from 'bootstrap-vue';
import Help from "./Help.vue";
import { validationMixin } from "vuelidate";
import { helpers, required, minValue, minLength, maxLength, url } from 'vuelidate/lib/validators';
import {Cnst} from '@/plugins/Cnst.js';

//const itemNameR = helpers.regex('itemNameR',/^(?!\.)(?!.*?[-\s]{2})(?!.*?[']{3})[a-zA-Z0-9.,()\-'а-яА-ЯёЁ\s]+$/);
const itemNameR = helpers.regex('itemNameR',/^(?!\.)(?!.*?[\s]{2})(?!.*?[-]{2})(?!.*?(\s-\S))(?!.*?[']{3})(?!.*?["]{3})[a-zA-Z0-9.,():\-'"а-яА-ЯёЁ\s]+$/);

export default {
  name: 'ManageCompany',
  components: {
    Help,
    BContainer, BRow, BCol, BButton, BFormGroup, BFormInput,
    BFormInvalidFeedback, BSpinner, BFormRadio
  },
  mixins: [validationMixin],
  data: function() {
    return {
        userName: '',
        companyName: '',
        curCompanyName: '',
        address: '',
        addrUrl: '',
        homeUrl: '',
        bookUrl: '',
        phones: '',
        email: '',
        other: '',
        contacts: '',
        url: '',
        act: 'editCompany',
        intLoc: this.$i18n.locale,
        helpName: 'HelpManageCompany',
        showHelp: false,
        loading: false,
        selected: ''
    }
  },
  metaInfo() {
    return {
        title: 'itsmap.ru'
    }
  },
  mounted() {
    this.userName = this.$store.state.curUserName;
    if(!this.userName) this.$showErr(this.$t('TMOUT'), 401);
    this.companyName = this.$rmEncHyp(this.$route.params.companyName);
    if(this.companyName == '_') {
        this.companyName = '';
        this.act = 'createCompany';
    }
    else this.getCompany();
  },
  methods: {
    async getCompany() {
        this.curCompanyName = this.companyName;
        try {
            this.loading = true;
            const response = await this.$http.get('/getCompany', {
                params: {
                    companyName: this.companyName,
                    userName: this.userName,
                    intLoc: this.intLoc
                }
            });
            let company = response.data;
            this.companyName = company.companyName;
            this.homeUrl = company.homeUrl;
            this.selected = company.resLoc;
        }
        catch(error) {
            if(typeof error.response === 'undefined') this.$serveErr('ManageCompany: getCompany() '+error.message);
            else this.$showErr(error.response.data, error.response.status);
        }
        finally {
            this.loading = false;
        }
    },
    validateState(name) {
        const { $dirty, $error } = this.$v[name];
        return $dirty ? !$error : null;
    },
    async ok() {
        if(this.loading) return;
        this.$v.$touch();
        if(this.$v.$anyError) return;
        try {
            this.loading = true;
            await this.$http.post('/'+this.act, {
                companyName: this.companyName,
                curCompanyName: this.curCompanyName,
                homeUrl: this.homeUrl,
                intLoc: this.selected
            });
            this.$showMsg(this.$t('DONE'));
            this.$router.push({
                path: '/CompaniesList'
            }).catch( () => {} )
        } catch(error) {
            if(typeof error.response === 'undefined') this.$serveErr('ManageCompany: ok() '+error.message);
            else this.$showErr(error.response.data, error.response.status);
        }
        finally {
            this.loading = false;
        }

    },
    cancel() {
        this.$router.go(-2);
    }
  },
  validations: {
      companyName: {
          required,
          itemNameR,
          minLength: minLength(2),
          maxLength: maxLength(Cnst.MAX_ITEM_NAME_SIZE)
      },
      homeUrl: {
          url,
          minLength: minLength(4),
          maxLength: maxLength(Cnst.MAX_ITEM_NAME_SIZE)
      },
      maxSize: {
        minValue: minValue(0)
      }
  },
  watch: {
    '$store.state.intLoc': function() {
        this.intLoc = this.$store.state.intLoc;
    }
  }
}

</script>

<style>
</style>